import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setAllProfilesPage = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<number>((state, action) => {
    state.allProfiles.page = action.payload;
  });
